// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-silver: #c0c0c0;
    --light-silver: #e8e8e8;
    --silver-gray: #f5f5f5;
    --dark-gray: #4a4a4a;
    --white: #ffffff;
    --text-dark: #2c2c2c;
    --accent-silver: #d3d3d3;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--text-dark);
    background-color: var(--white);
}

html {
    scroll-behavior: smooth;
}

/* Navigation */
.navbar {
    background-color: var(--white) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    padding: 1rem 0;
}

.navbar-brand {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--text-dark) !important;
    letter-spacing: 0.5px;
    text-decoration: none;
}

.logo-icon {
    margin-right: 12px;
    display: flex;
    align-items: center;
}

.logo-text {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--text-dark);
}

.nav-link {
    color: var(--dark-gray) !important;
    font-weight: 500;
    margin: 0 0.5rem;
    transition: color 0.3s ease;
    cursor: pointer;
}

.nav-link:hover {
    color: var(--primary-silver) !important;
}

/* Hero Section */
.hero-section {
    min-height: 100vh;
    display: flex;
    align-items: center;
    background: linear-gradient(135deg, var(--silver-gray) 0%, var(--white) 50%, var(--light-silver) 100%);
    padding: 100px 0 80px;
}

.hero-content h1 {
    font-size: 3.5rem;
    font-weight: 700;
    color: var(--text-dark);
    margin-bottom: 1.5rem;
    line-height: 1.2;
}

.hero-content p {
    font-size: 1.3rem;
    color: var(--dark-gray);
    margin-bottom: 2rem;
    line-height: 1.6;
}

.btn-primary-custom {
    background-color: var(--primary-silver);
    border: 2px solid var(--primary-silver);
    color: var(--white);
    padding: 12px 35px;
    font-size: 1.1rem;
    font-weight: 600;
    border-radius: 5px;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
}

.btn-primary-custom:hover {
    background-color: transparent;
    color: var(--primary-silver);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(192, 192, 192, 0.3);
}

/* Section Styling */
section {
    padding: 80px 0;
}

.section-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--text-dark);
    margin-bottom: 1rem;
    position: relative;
    display: inline-block;
}

.section-title::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 3px;
    background-color: var(--primary-silver);
}

.section-subtitle {
    font-size: 1.1rem;
    color: var(--dark-gray);
    margin-bottom: 3rem;
}

/* About Section */
.about-section {
    background-color: var(--white);
}

.about-content {
    font-size: 1.1rem;
    line-height: 1.8;
    color: var(--dark-gray);
}

.about-highlight {
    background-color: var(--silver-gray);
    padding: 30px;
    border-radius: 8px;
    margin-top: 30px;
}

.about-highlight h4 {
    color: var(--text-dark);
    font-weight: 600;
    margin-bottom: 15px;
}

/* Services Section */
.services-section {
    background-color: var(--silver-gray);
}

.service-card {
    background-color: var(--white);
    padding: 40px 30px;
    border-radius: 8px;
    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    height: 100%;
    border: 1px solid var(--light-silver);
    cursor: pointer;
}

.service-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.service-icon {
    font-size: 3rem;
    color: var(--primary-silver);
    margin-bottom: 20px;
}

.service-card h3 {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--text-dark);
    margin-bottom: 15px;
}

.service-card p {
    color: var(--dark-gray);
    line-height: 1.7;
}

/* Contact Section */
.contact-section {
    background-color: var(--white);
}

.contact-info {
    text-align: center;
}

.contact-item {
    background-color: var(--silver-gray);
    padding: 40px 30px;
    border-radius: 8px;
    margin-bottom: 40px;
}

.contact-icon {
    font-size: 3.5rem;
    margin-bottom: 15px;
}

.contact-item h3 {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--text-dark);
    margin-bottom: 15px;
}

.contact-link {
    font-size: 1.3rem;
    color: var(--primary-silver);
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    display: inline-block;
}

.contact-link:hover {
    color: var(--dark-gray);
    transform: translateY(-2px);
}

.social-links {
    margin-top: 20px;
}

.social-links h3 {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--text-dark);
    margin-bottom: 30px;
}

.social-icons {
    display: flex;
    justify-content: center;
    gap: 30px;
    flex-wrap: wrap;
}

.social-icon {
    color: var(--primary-silver);
    transition: all 0.3s ease;
    display: inline-block;
    cursor: pointer;
}

.social-icon:hover {
    color: var(--dark-gray);
    transform: translateY(-5px);
}

.social-icon svg {
    width: 45px;
    height: 45px;
}

/* Footer */
.footer {
    background-color: var(--text-dark);
    color: var(--light-silver);
    padding: 30px 0;
    text-align: center;
}

.footer p {
    margin: 0;
    font-size: 0.95rem;
}

/* Responsive */
@media (max-width: 768px) {
    .hero-content h1 {
        font-size: 2.5rem;
    }

    .hero-content p {
        font-size: 1.1rem;
    }

    .section-title {
        font-size: 2rem;
    }

    section {
        padding: 60px 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI;;kBAEc;IACd,mCAAmC;IACnC,kCAAkC;IAClC,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI,yCAAyC;IACzC,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sGAAsG;IACtG,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,oBAAoB;AACpB;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,WAAW;IACX,WAAW;IACX,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,yBAAyB;IACzB,YAAY;IACZ,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,WAAW;AACX;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[":root {\r\n    --primary-silver: #c0c0c0;\r\n    --light-silver: #e8e8e8;\r\n    --silver-gray: #f5f5f5;\r\n    --dark-gray: #4a4a4a;\r\n    --white: #ffffff;\r\n    --text-dark: #2c2c2c;\r\n    --accent-silver: #d3d3d3;\r\n}\r\n\r\n* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n        sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    color: var(--text-dark);\r\n    background-color: var(--white);\r\n}\r\n\r\nhtml {\r\n    scroll-behavior: smooth;\r\n}\r\n\r\n/* Navigation */\r\n.navbar {\r\n    background-color: var(--white) !important;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\r\n    padding: 1rem 0;\r\n}\r\n\r\n.navbar-brand {\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    color: var(--text-dark) !important;\r\n    letter-spacing: 0.5px;\r\n    text-decoration: none;\r\n}\r\n\r\n.logo-icon {\r\n    margin-right: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.logo-text {\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    color: var(--text-dark);\r\n}\r\n\r\n.nav-link {\r\n    color: var(--dark-gray) !important;\r\n    font-weight: 500;\r\n    margin: 0 0.5rem;\r\n    transition: color 0.3s ease;\r\n    cursor: pointer;\r\n}\r\n\r\n.nav-link:hover {\r\n    color: var(--primary-silver) !important;\r\n}\r\n\r\n/* Hero Section */\r\n.hero-section {\r\n    min-height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    background: linear-gradient(135deg, var(--silver-gray) 0%, var(--white) 50%, var(--light-silver) 100%);\r\n    padding: 100px 0 80px;\r\n}\r\n\r\n.hero-content h1 {\r\n    font-size: 3.5rem;\r\n    font-weight: 700;\r\n    color: var(--text-dark);\r\n    margin-bottom: 1.5rem;\r\n    line-height: 1.2;\r\n}\r\n\r\n.hero-content p {\r\n    font-size: 1.3rem;\r\n    color: var(--dark-gray);\r\n    margin-bottom: 2rem;\r\n    line-height: 1.6;\r\n}\r\n\r\n.btn-primary-custom {\r\n    background-color: var(--primary-silver);\r\n    border: 2px solid var(--primary-silver);\r\n    color: var(--white);\r\n    padding: 12px 35px;\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n    border-radius: 5px;\r\n    transition: all 0.3s ease;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-primary-custom:hover {\r\n    background-color: transparent;\r\n    color: var(--primary-silver);\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 5px 15px rgba(192, 192, 192, 0.3);\r\n}\r\n\r\n/* Section Styling */\r\nsection {\r\n    padding: 80px 0;\r\n}\r\n\r\n.section-title {\r\n    font-size: 2.5rem;\r\n    font-weight: 700;\r\n    color: var(--text-dark);\r\n    margin-bottom: 1rem;\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.section-title::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -10px;\r\n    left: 0;\r\n    width: 60px;\r\n    height: 3px;\r\n    background-color: var(--primary-silver);\r\n}\r\n\r\n.section-subtitle {\r\n    font-size: 1.1rem;\r\n    color: var(--dark-gray);\r\n    margin-bottom: 3rem;\r\n}\r\n\r\n/* About Section */\r\n.about-section {\r\n    background-color: var(--white);\r\n}\r\n\r\n.about-content {\r\n    font-size: 1.1rem;\r\n    line-height: 1.8;\r\n    color: var(--dark-gray);\r\n}\r\n\r\n.about-highlight {\r\n    background-color: var(--silver-gray);\r\n    padding: 30px;\r\n    border-radius: 8px;\r\n    margin-top: 30px;\r\n}\r\n\r\n.about-highlight h4 {\r\n    color: var(--text-dark);\r\n    font-weight: 600;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n/* Services Section */\r\n.services-section {\r\n    background-color: var(--silver-gray);\r\n}\r\n\r\n.service-card {\r\n    background-color: var(--white);\r\n    padding: 40px 30px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);\r\n    transition: all 0.3s ease;\r\n    height: 100%;\r\n    border: 1px solid var(--light-silver);\r\n    cursor: pointer;\r\n}\r\n\r\n.service-card:hover {\r\n    transform: translateY(-5px);\r\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.service-icon {\r\n    font-size: 3rem;\r\n    color: var(--primary-silver);\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.service-card h3 {\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    color: var(--text-dark);\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.service-card p {\r\n    color: var(--dark-gray);\r\n    line-height: 1.7;\r\n}\r\n\r\n/* Contact Section */\r\n.contact-section {\r\n    background-color: var(--white);\r\n}\r\n\r\n.contact-info {\r\n    text-align: center;\r\n}\r\n\r\n.contact-item {\r\n    background-color: var(--silver-gray);\r\n    padding: 40px 30px;\r\n    border-radius: 8px;\r\n    margin-bottom: 40px;\r\n}\r\n\r\n.contact-icon {\r\n    font-size: 3.5rem;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.contact-item h3 {\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    color: var(--text-dark);\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.contact-link {\r\n    font-size: 1.3rem;\r\n    color: var(--primary-silver);\r\n    text-decoration: none;\r\n    font-weight: 500;\r\n    transition: all 0.3s ease;\r\n    display: inline-block;\r\n}\r\n\r\n.contact-link:hover {\r\n    color: var(--dark-gray);\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.social-links {\r\n    margin-top: 20px;\r\n}\r\n\r\n.social-links h3 {\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    color: var(--text-dark);\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.social-icons {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 30px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.social-icon {\r\n    color: var(--primary-silver);\r\n    transition: all 0.3s ease;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n}\r\n\r\n.social-icon:hover {\r\n    color: var(--dark-gray);\r\n    transform: translateY(-5px);\r\n}\r\n\r\n.social-icon svg {\r\n    width: 45px;\r\n    height: 45px;\r\n}\r\n\r\n/* Footer */\r\n.footer {\r\n    background-color: var(--text-dark);\r\n    color: var(--light-silver);\r\n    padding: 30px 0;\r\n    text-align: center;\r\n}\r\n\r\n.footer p {\r\n    margin: 0;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n    .hero-content h1 {\r\n        font-size: 2.5rem;\r\n    }\r\n\r\n    .hero-content p {\r\n        font-size: 1.1rem;\r\n    }\r\n\r\n    .section-title {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    section {\r\n        padding: 60px 0;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
